<template>
    <div class="about__list">
        <div class="about__item">
            <div class="about__item-table">
                <div class="about__item-table__column auto header">
                    <template v-for="(head, index) in lottoPermBet.header" :key="index">
                        <div class="about__item-table__column-item">
                            <span class="about__item-table__column-item-text">
                                {{ getTranslatedText(head.title) }}
                            </span>
                        </div>
                    </template>
                </div>

                <div class="about__item-table__column full">
                    <template v-for="(body, index) in lottoPermBet.body" :key="index">
                        <div class="about__item-table__column auto">
                            <div class="about__item-table__column-item">
                                <span class="about__item-table__column-item-text">
                                    {{ getTranslatedText(body.name) }}
                                </span>
                            </div>
                            <div class="about__item-table__column-item">
                                <span class="about__item-table__column-item-text">
                                    {{
                                        getTranslatedText(body.description, {
                                            pick: body.desPick,
                                            to: body.desTo,
                                            least: body.desLeast,
                                        })
                                    }}
                                </span>
                            </div>
                            <div class="about__item-table__column-item">
                                <span class="about__item-table__column-item-text">
                                    {{ body.multiplier }}
                                </span>
                            </div>
                            <div class="about__item-table__column-item">
                                <span class="about__item-table__column-item-text">
                                    {{
                                        getTranslatedText(body.exampleStake, {
                                            symbol: $store.state.config.setup?.symbol,
                                        })
                                    }}
                                </span>
                            </div>
                            <div class="about__item-table__column-item">
                                <span class="about__item-table__column-item-text">
                                    {{
                                        getTranslatedText(body.winningExample, {
                                            symbol: $store.state.config.setup?.symbol,
                                        })
                                    }}
                                </span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="about__item">
            <div class="about__item-table">
                <div class="about__item-table__column auto header">
                    <template v-for="(head, index) in lottoPermLine.header" :key="index">
                        <div class="about__item-table__column-item">
                            <span class="about__item-table__column-item-text">
                                {{ getTranslatedText(head.title) }}
                            </span>
                        </div>
                    </template>
                </div>

                <div class="about__item-table__column full">
                    <template v-for="(body, index) in lottoPermLine.body" :key="index">
                        <div class="about__item-table__column auto">
                            <div class="about__item-table__column-item">
                                <span class="about__item-table__column-item-text">
                                    {{ body.numbersSelected }}
                                </span>
                            </div>
                            <div class="about__item-table__column-item">
                                <span class="about__item-table__column-item-text">
                                    {{ body.perm2Lines }}
                                </span>
                            </div>
                            <div class="about__item-table__column-item">
                                <span class="about__item-table__column-item-text">
                                    {{ body.perm3Lines }}
                                </span>
                            </div>
                            <div class="about__item-table__column-item">
                                <span class="about__item-table__column-item-text">
                                    {{ body.perm4Lines }}
                                </span>
                            </div>
                            <div class="about__item-table__column-item">
                                <span class="about__item-table__column-item-text">
                                    {{ body.perm5Lines }}
                                </span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import { lottoPermBet, lottoPermLine } from '@/resource/about/loto';

export default {
    mixins: [languageMixins],
    data() {
        return {
            lottoPermBet,
            lottoPermLine,
        };
    },
};
</script>
